module.exports = {
  _setDeepValue: function (context, path, value) {
    var obj = context.state
    var current = obj
    var stack = path.split('.')
    while (stack.length > 1) {
      current = current[stack.shift()]
    }
    current[stack.shift()] = value
    return obj
  },
  setValueAtPath: function (context, path, value) {
    context.setState(this._setDeepValue(context, path, value))
  },
  getValueFromPath: function (context, path) {
    var obj = context.state
    var stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/helpers/state.js